import React, { useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { VehicleCard } from './VehicleCard';
import { Reveal } from './Reveal';
import { vehicles } from '../data/catalog';
import type { VehicleSegment } from '../types/catalog';
import { useLanguage } from '../contexts/LanguageContext';
type Filter = 'all' | VehicleSegment;
const filterKeys: Filter[] = ['all', 'Deportivos', 'SUV', 'Eléctricos', 'Sedanes'];
export function VehicleLineup() {
  const {
    t
  } = useLanguage();
  const [filter, setFilter] = useState<Filter>('all');
  const labels = t.filters as Record<string, string>;
  const visible = useMemo(() => filter === 'all' ? vehicles : vehicles.filter(v => v.segment === filter), [filter]);
  return <section id="inventario" aria-labelledby="inventario-title" className="scroll-mt-24 border-t border-line bg-canvas py-20 sm:py-28 lg:py-44" data-id="element-317" data-mp="1je5rvawks8k6">
      <div className="mx-auto max-w-[1520px] px-5 sm:px-6 lg:px-14" data-id="element-318" data-mp="3dosz9il026rl">
        <Reveal className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between" data-id="element-319" data-mp="1t6zhex4q7461">
          <div data-id="element-320" data-mp="1o8y0oiurvgxq">
            <p className="text-[11px] uppercase tracking-[0.34em] text-mute" data-id="element-321" data-mp="1o97p42065g1b">{t.lineup.eyebrow}</p>
            <h2 id="inventario-title" className="mt-5 max-w-xl text-[34px] font-light tracking-[-0.03em] text-white lg:text-[52px]" data-id="element-322" data-mp="22xlvgmwsnmmm">
              {t.lineup.title}
            </h2>
          </div>

          <div role="group" aria-label={t.lineup.filterAria} className="-mx-5 flex gap-2 overflow-x-auto px-5 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0" data-id="element-323" data-mp="1a8wzt3eic9i9">
            {filterKeys.map(option => {
            const active = option === filter;
            return <button key={option} type="button" onClick={() => setFilter(option)} aria-pressed={active} className={`whitespace-nowrap border px-6 py-2.5 text-[12px] tracking-wide transition-colors duration-500 ease-[var(--ease-lux)] ${active ? 'border-guards bg-guards text-white' : 'border-line bg-canvas text-mute hover:border-guards/60 hover:text-white'}`} data-id="element-324" data-mp="2umxa9nxbzq7a">
                  {labels[option]}
                </button>;
          })}
          </div>
        </Reveal>

        <Reveal data-id="element-325" data-mp="19jt7iqwkbm99">
          <motion.ul layout className="mt-10 grid grid-cols-1 gap-6 sm:mt-16 sm:grid-cols-2 sm:gap-8 lg:mt-24 lg:grid-cols-3" data-id="element-326" data-mp="19le0ic38ax50">
            <AnimatePresence mode="popLayout" initial={false} data-id="element-327" data-mp="1idfxg0e39vaj">
              {visible.map((vehicle, index) => <motion.li key={vehicle.id} layout initial={{
              opacity: 0,
              y: 40,
              scale: 0.98
            }} animate={{
              opacity: 1,
              y: 0,
              scale: 1
            }} exit={{
              opacity: 0,
              y: 20,
              scale: 0.98
            }} transition={{
              duration: 0.8,
              ease: [0.16, 1, 0.3, 1],
              delay: Math.min(index * 0.08, 0.32)
            }} className="h-full" data-id="element-328" data-mp="lvtetlfoxls1" data-mpi={index}>
                  <VehicleCard vehicle={vehicle} data-id="element-329" data-mp="4cjhtu2a8ksz" />
                </motion.li>)}
            </AnimatePresence>
          </motion.ul>
        </Reveal>

        <Reveal data-id="element-330" data-mp="3qt5v70ae13gb">
          <p className="mt-14 max-w-3xl text-[11px] leading-relaxed text-mute" data-id="element-331" data-mp="3qsnqdf9ntgws">
            {t.lineup.disclaimer}
          </p>
        </Reveal>
      </div>
    </section>;
}